const Plyr = require('plyr');
//import Glide, { Controls, Breakpoints } from '@glidejs/glide/dist/glide.modular.esm'
import Glide  from '@glidejs/glide'
//import TweenMax from "@gsap/TweenMax";
// eslint-disable-next-line
import {TweenLite, CSSPlugin, ScrollToPlugin, AttrPlugin, TimelineMax, Expo, Back, Elastic, Power1, TweenMax } from "gsap/all";

// eslint-disable-next-line
const plugins = [CSSPlugin, ScrollToPlugin, AttrPlugin];

import './cookieconsent-init';

/* eslint-disable import/first */
// import Seriously from '../vendor/seriously/seriously.js';

/* eslint-disable import/first */
import "@babel/polyfill";
/* eslint-disable import/first */
import 'nodelist-foreach-polyfill';
import axios from 'axios';
import '@fancyapps/fancybox';
import './iside';


export default {

  init() {
    initPageNav();
    initModals();
    initTabs();
    initShare();
    initScrollTo();
    initCarousel();
    initMenu();
    initSpy();
    initGoogleForm();
    initTabCarousel();
    initHowToAnim();
    patternAnim();
    teamPhothoAnim();
    initCouponCodeCheck();
    initAnimateTitle();
    initUmcuBlock();

    const heroVideo = document.querySelectorAll('.anim-blur');

    heroVideo.forEach(function (item) {
      initHeroVideo(item)
    });

    function initCouponCodeCheck(){
      const voucherCode = document.getElementById("voucher-code");
      const validate = document.getElementById("validate");
      const startExam = document.getElementById("startExam");

      if (voucherCode) {
        if (
                voucherCode.value && (voucherCode.value.toUpperCase() === voucherCode.dataset.validate.toUpperCase() )
            ) {
              validate.classList.add("valid");
              startExam.classList.remove("disabled");
            }
       // validate.addEventListener("click", checkVoucher);
        voucherCode.addEventListener("keyup", () => {
            validate.classList.remove("valid");
            startExam.classList.add("disabled");
            //errorField.classList.add("hide");
            if (
                voucherCode.value && (voucherCode.value.toUpperCase() === voucherCode.dataset.validate.toUpperCase() )
            ) {
              validate.classList.add("valid");
              startExam.classList.remove("disabled");
            }
        });
      }
    }



    function teamPhothoAnim(){
      const items = document.querySelectorAll('.easee-team-carousel');

      items.forEach(function (item) {
        const quotes = item.querySelectorAll('blockquote');

        quotes.forEach(function (q) {
          q.addEventListener("mouseenter", function () {
            this.closest("li").classList.add('active')
          });

          q.addEventListener("mouseleave", function () {
            this.closest("li").classList.remove('active')
          });
        })

      })
    }

    function initAnimateTitle() {
      //anim-title
      const items = document.querySelectorAll(".anim-title");

      items.forEach(function(item) {
        let t = new TimelineMax({ repeat: -1 });
        let titles = item.querySelectorAll("span");
        titles.forEach(function(i) {
          t.to(
            i,
            0.4,
            {
              opacity: 1,
              ease: Back.easeOut,
            },
            "+=0"
          )

          .to(
            i,
            0.4,
            {
              opacity: 0,
              transformOrigin: "50% 50%",
              ease: Back.easeOut,
            },
            "+=6"
          )

        })

      });
    }

    function patternStagger(shape, item) {
      const duration = 4
      const shapes = ["plus","tri","circle","line","plus","tri","circle","line","plus","tri","circle","line"]
      const cIndex = shapes.indexOf(shape)
      const current = item.querySelectorAll('.pattern-'+ shape);

      TweenLite.set(current,{transformOrigin: '50% 50%'})

      const tl = new TimelineMax({repeat: -1, delay: cIndex, id: cIndex+1 });

      tl
        .staggerTo(current, 0.5,
          {
          morphSVG:"#"+shapes[cIndex+1],
          delay: duration,
          ease: Power1.easeOut,
          stagger: {
            from: "center",
            each: 0.2,
            grid: "auto",
          },
        })

        .staggerTo(current, 0.5, {
          morphSVG:"#"+shapes[cIndex+2],
          delay: duration,
          ease: Power1.easeOut,
          stagger: {
            from: "center",
            each: 0.2,
            grid: "auto",
          },
        })

        .staggerTo(current, 0.5, {
          morphSVG:"#"+shapes[cIndex+3],
          delay: duration,
          ease: Power1.easeOut,
          stagger: {
            from: "center",
            each: 0.2,
            grid: "auto",
          },
        })

        .staggerTo(current, 0.5, {
          morphSVG:"#"+shapes[cIndex+4],
          delay: duration,
          ease: Power1.easeOut,
          stagger: {
            from: "center",
            each: 0.2,
            grid: "auto",
          },
        })



    }

    function patternAnim(){
      const svg = document.querySelectorAll('.easee-pattern');
      svg.forEach(function (item) {
        patternStagger("tri",item);
        patternStagger("circle",item);
        patternStagger("plus",item);
        patternStagger("line",item);

      })
    }

    function initHowToAnim() {
      //
      const svg = document.querySelectorAll('.how-slider');
      svg.forEach(function (item) {
        const pupils = item.querySelectorAll("[data-name='pupil']");
        const hairBg = item.querySelectorAll("[data-name='hair-bg']");
        const hairBg2 = item.querySelectorAll("[data-name='hair-bg-2']");
        const hand = item.querySelectorAll("[data-name='hand']");
        const handPhone = item.querySelectorAll("[data-name='hand2']");
        const light = item.querySelectorAll("[data-name='light']");
        const screenEl = item.querySelectorAll("[data-name='screen-el']");
        const chart = item.querySelectorAll("[data-name='pie-stroke']");
        const header = item.querySelectorAll("[data-name='header']");


        if (pupils.length > 0) {
          let tl = new TimelineMax({delay: 0.5, repeat: -1, repeatDelay: 2});
          tl.to(pupils, 2, {x: -4, ease: Elastic.easeOut.config(1, 0.75)})
          tl.to(pupils, 2, {x: -4})
          tl.to(pupils, 2, {x: 4, ease: Elastic.easeOut.config(1, 0.75)})
          tl.to(pupils, 0.6, {x: 4})
          tl.to(pupils, 2, {x: 0, ease: Elastic.easeOut.config(1, 0.75)})
          tl.to(pupils, 1, {x: 0})
        }

        if (hairBg.length > 0 && hairBg2.length > 0) {
          let tl2 = new TimelineMax({repeat: -1});
          tl2
            .to(hairBg, 4, {morphSVG: hairBg2, ease: Power1.easeOut})
            .to(hairBg, 4, {morphSVG: hairBg, ease: Power1.easeIn});
        }

        if (hand.length > 0) {
          let tl3 = new TimelineMax({delay: 0.8, repeat: -1, repeatDelay: 4});
          tl3
            .to(hand, 1, {y: 5})
            .to(hand, 1, {y: 0})
        }

        if (light.length > 0) {
          let tl5 = new TimelineMax({delay: 0.8, repeat: -1, repeatDelay: 4});
          tl5
            .from(light, 2, {opacity: 0})
            .to(light, 1, {opacity: 1})
            .to(light, 1, {opacity: 0.5}, "+=2")
            .to(light, 1, {opacity: 1}, "+=2")
            .to(light, 1, {opacity: 0}, "+=2")
        }
        if (screenEl.length > 0) {
          TweenLite.set(screenEl, {transformOrigin: '100% 100%'});
          TweenLite.set(header, {transformOrigin: '50% 50%'});
          let tl6 = new TimelineMax({delay: 0.8, repeat: -1, repeatDelay: 0.2, yoyo: true});
          tl6
            .staggerFrom(screenEl, 0.6, {opacity: 0, scaleY: 0.6, y: -20, ease: Expo.easeIn}, 0.4)
            .staggerFrom(chart, 1, {drawSVG: "0%", ease: Expo.easeOut}, 0.2)
            .staggerTo(chart, 1, {drawSVG: "75%", ease: Expo.easeIn}, 0.2)
            .to(header, 1, {scale: 1.05, ease: Expo.easeIn}, "+=2")
        }

        if (handPhone.length > 0) {
          TweenLite.set(handPhone, {transformOrigin: '100% 100%'});
          let tl4 = new TimelineMax({repeat: -1});
          tl4
            .to(handPhone, 8, {y: 10, rotation: -2, ease: Power1.easeInOut})
            .to(handPhone, 8, {y: 0, rotation: 0, ease: Power1.easeInOut})
        }
      })

    }

    function initTabCarousel() {
      const tabs = document.querySelectorAll('.easee-block-carousel');
      tabs.forEach(function (item) {
        const tabsLinks = item.querySelectorAll('.easee-tab-link');
        const tabText = item.querySelectorAll('.easee-tab-text');
        const tabImages = item.querySelectorAll('.easee-tab-image');
        const tabTitles = item.querySelectorAll('.easee-tab-titles');
        tabsLinks.forEach(function (link) {
          link.addEventListener("click", function (event) {
            TweenLite.to(item, 0.6, {"--section-bg-color": this.dataset.bgColor})
            TweenLite.to(item, 0.6, {"--section-color": this.dataset.textColor})
            event.preventDefault();
            let activeTabId = this.getAttribute('href')
            let activeTab = document.querySelectorAll(`[data-rel='${activeTabId}']`)

            tabsLinks.forEach(function (el) {
              el.classList.remove("active")
            })

            tabText.forEach(function (el) {
              el.classList.remove("active")
            })

            tabImages.forEach(function (el) {
              el.classList.remove("active")
            })
            tabTitles.forEach(function (el) {
              el.classList.remove("active")
            })

            this.classList.add("active")


            activeTab.forEach(function (el) {
              el.classList.add("active")
            })
            //TweenLite.to(window, 0.6, {scrollTo: this.getAttribute('href')});
          })
        })

      });
    }


    function initGoogleForm() {
      let doSubmit = false;
      const grecaptchaDiv = document.querySelector('#grecaptcha-div');
      let RC2KEY = '6LceFnEUAAAAACKruqWOI5y7_Ut_JnmlQ4b83gCD\n';

      function reCaptchaVerify(response) {
        //console.warn(response)
        if (response === document.querySelector('.g-recaptcha-response').value) {
          doSubmit = true;

          grecaptchaDiv.classList.remove('error')
        }
      }

      function reCaptchaExpired() {
        /* do something when it expires */
      }

      // eslint-disable-next-line
      function reCaptchaCallback() {
        // eslint-disable-next-line
        grecaptcha.render('grecaptcha-div', {
          'sitekey': RC2KEY,
          'callback': reCaptchaVerify,
          'expired-callback': reCaptchaExpired,
        });
      }

      function slackIt(channel) {
        let formData = new FormData(form)
        let string = '';

        formData.forEach(function (value) {
          if (value && value != 'therms' && value.length < 60)
            string += `${value}\n`
        });

        const url = 'https://hooks.slack.com/services/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'
        if (channel) {
          axios.post(url, 'payload=' + JSON.stringify(
            {
              "text": ">>> New Lead <<<\n" + string,
              "channel": channel,
              "username": "wordpress",
              "icon_emoji": ":fire:",
            }), {
            withCredentials: false,
          })
        }
      }


      const form = document.querySelector('#googleForm');

      if (form == null) return false;
      window.reCaptchaCallback = reCaptchaCallback;
      const thankyou = document.querySelector('#thankyou');

      let head = document.getElementsByTagName('head')[0];
      let script = document.createElement('script');
      script.type = 'text/javascript';
      script.onload = function () {
      }
      script.src = 'https://www.google.com/recaptcha/api.js?onload=reCaptchaCallback&render=explicit';
      head.appendChild(script);

      form.addEventListener("submit", function (e) {
          e.preventDefault();
          if (doSubmit) {
            slackIt(form.dataset.slack);
            form.classList.add('hidden');
            thankyou.classList.remove('hidden');
            form.submit()
          }
          else {
            grecaptchaDiv.classList.add('error')
          }
        }
      );


    }

    function initPageNav() {
      const links = document.querySelectorAll('.anchor-block');
      let linksArray = Array.from(links);
      const markup =
        `${linksArray.map(link => `<li> <a href="#${link.id} " class="scroll-to scroll-spy" data-scroll="${link.id}" aria-hidden="true"> scroll </a> </li>`).join('')}`

      let elem = document.createElement('ul');
      elem.className = "page-scroll-nav";
      elem.innerHTML = markup;
      document.body.appendChild(elem);
    }

    function initMenu() {

      const icon = document.querySelector('.brand');
      const close = document.querySelector('.close-menu');
      const header = document.querySelector('header.banner');
      const pageContent = document.querySelector('body');
      let tl;
      initMenuAnim();


      window.addEventListener('resize', resizeMenu);
      icon
        .addEventListener("click", function (event) {
          if (!header.classList.contains('active')) {
            event.preventDefault();
            TweenLite.to("#l1_top", 0.2, {morphSVG: "#l1_top"});
            TweenLite.to("#l1_bottom", 0.2, {morphSVG: "#l1_bottom"});
            tl.play('start')
            pageContent.classList.toggle("menu-active");
            header.classList.toggle("active");
          }
        });

      close
        .addEventListener("click", function (event) {
          if (header.classList.contains('active')) {
            event.preventDefault();
            tl.reverse()
            pageContent.classList.toggle("menu-active");
            header.classList.toggle("active");
          }
        });

      icon
        .addEventListener("mouseenter", function () {
          if (header.classList.contains('active')) return false;
          TweenLite.to("#l1_top", 0.4, {morphSVG: "#l1__hover_top"});
          TweenLite.to("#l1_bottom", 0.4, {morphSVG: "#l1__hover_bottom"});
        });

      icon
        .addEventListener("mouseleave", function () {
          TweenLite.to("#l1_top", 0.4, {morphSVG: "#l1_top"});
          TweenLite.to("#l1_bottom", 0.4, {morphSVG: "#l1_bottom"});
        });


      function resizeMenu() {
        tl.seek(0).kill();
        initMenuAnim();
        if (header.classList.contains('active')) {
          pageContent.classList.toggle("menu-active");
          header.classList.toggle("active");
        }
      }

      function initMenuAnim() {
        tl = new TimelineMax();
        let menuWidth = (window.innerWidth >= window.innerHeight) ? '100vh' : window.innerWidth;
        let brandLeft = (window.innerWidth > 900) ? '8vh' : '20px';
        let enlargeBg = 2 / (60 / window.innerHeight);


        tl
          .to(".menu-bg", 0.4, {x: '0', y: '0', scale: enlargeBg, ease: Expo.easeIn}, 'start')
          .to(".menu-bg", 0.5, {borderRadius: 0, ease: Expo.easeOut}, 'start+=0.4')
          .to(".brand", 0.6, {width: 110, ease: Expo.easeOut}, 'start+=0.1')

          .to(header, 0.6, {width: menuWidth, ease: Expo.easeIn}, 'start+=0.1')
          .to("#logoSvg", 0.6, {
            attr: {
              viewBox: "0 0 1000 181.64",
            },
            width: 110,
            ease: Expo.easeIn,
          }, 'start+=0.1')

          .to(".brand", 0.6, {x: brandLeft, ease: Expo.easeIn}, 'start+=0.1')

          .to(".nav-primary", 0.01, {x: 50, width: menuWidth, opacity: 0, ease: Expo.easeIn}, 'start+=0.1')
          .to(".nav-primary", 0.6, {x: "0", opacity: 1, ease: Expo.easeIn}, 'start+=0.14')
          .to(".close-menu", 0.6, {opacity: 1, ease: Expo.easeIn}, 'start+=0.31')
          .stop();
      }
    }

    function initCarousel() {
      const carousels = document.querySelectorAll(".glide");
      if (carousels.length <= 0) return false;

      carousels.forEach(function(carousel) {
        let inScreen = carousel.dataset.inview ? carousel.dataset.inview : 3;
        let inScreenM = (inScreen - 1 > 1) ? inScreen - 1 : 1;
        let play = carousel.dataset.play ? carousel.dataset.play : 0;


        let glide = new Glide(carousel, {
          type: "carousel",
          startAt: 0,
          autoplay: parseInt(play),
          perView: inScreen,
          gap: 0,
          focusAt: 0,
          peek: 0,
          breakpoints: {
            850: {
              perView: 1,
            },
            1700: {
              perView: inScreenM,
            },
          },
        });
        glide.mount()
        setTimeout(function() {
          window.dispatchEvent(new Event('resize'))
          TweenMax.to(carousel,0.4,{opacity:1, ease: Expo.easeOut})
        }, 1000);
      });
    }


    function initHeroVideo(el) {
      let blur = 0.5;
      let hoverBtn = false;
      let canvas = el.querySelector(".canvas");
      // let video = el.querySelector(".video");
      let startBtn = el.querySelector(".btn-underline");
      canvas.getContext('webgl');

      canvas.width = window.innerWidth < 1280 ? window.innerWidth : 1280;
      canvas.height = (canvas.width * .5625);

      // let seriously = new Seriously();
      // let src = seriously.source(video)
      // let target = seriously.target(canvas)

      // let blurEffect = seriously.effect('blur');
      // var vigEffect = seriously.effect('vignette')
      // blurEffect.amount = blur;
      // vigEffect.amount = blur;
      // vigEffect.source = src;
      // blurEffect.source = vigEffect;
      // target.source = blurEffect;

      // seriously.go(function () {

      //   blurEffect.amount = (window.innerWidth > 440) ? blur * 0.4 : 0;
      //   vigEffect.amount = (window.innerWidth > 440) ? blur * 10 : 1;

      // });
      const debounce = (fn, time) => {
        let timeout;

        return function () {
          const functionCall = () => fn.apply(this, arguments);

          clearTimeout(timeout);
          timeout = setTimeout(functionCall, time);
        }
      }

      function updateHandler() {
        blur = currentBlur.val
      }

      let currentBlur = {val: blur}

      document.body.addEventListener('mousemove', debounce((e) => {
        if (!hoverBtn) {
          let distance = getDistance(startBtn, e.pageX, e.pageY);
          blur = Math.round(((distance / window.innerWidth) / 2) * 100) / 100;
        }
      }, 1));

      startBtn
        .addEventListener("mouseenter", function () {
          hoverBtn = true;
          currentBlur = {val: blur}
          TweenLite.to(currentBlur, 0.5, {val: 0, onUpdate: updateHandler, ease: Expo.easeOut});
        });

      startBtn
        .addEventListener("mouseleave", function () {
          hoverBtn = false;
        });


    }

    function initUmcuBlock() {
      const links = document.querySelectorAll('.btn_next');
      const slides = document.querySelectorAll('.umcu_slide');
      const block = document.querySelector('.easee-header-umcu');

      links.forEach(function (link) {
        link.addEventListener("click", function (event) {
          event.preventDefault();
          slides.forEach(function (el) {
            el.classList.remove("active")
          })
          let activeSlide = block.querySelector(this.hash)
          activeSlide.classList.add("active")
          location.hash = this.hash;

          //TweenLite.to(window, 0.6, {scrollTo: this.getAttribute('href')});
        })
      })
    }

    function initScrollTo() {
      const links = document.querySelectorAll('.scroll-to');

      links.forEach(function (link) {
        link.addEventListener("click", function (event) {
          event.preventDefault();
          TweenLite.to(window, 0.6, {scrollTo: this.getAttribute('href')});
        })
      })
    }

    function initSpy() {
      let links = document.querySelectorAll('[data-scroll]');
      let sections = {};
      let elements = {};

      let onScroll = () => {
        'use strict';

        let scrollPosition = window.scrollY + window.innerHeight / 2;

        for (let key in sections) {
          if (sections.hasOwnProperty(key)) {

            if (scrollPosition > sections[key]) {
              let activeItem = document.querySelector("[data-scroll='" + key + "']")
              let wasActive = document.querySelector('.scroll-spy.active')
              if (wasActive) wasActive.classList.remove('active');
              activeItem.classList.add('active');
            }
          }
        }
      };

      Array.prototype.forEach.call(links, (link) => {
        'use strict';

        let element = document.getElementById(link.getAttribute('data-scroll'));
        elements[element.id] = element;

      });

      for (let key in elements) {

        if (elements.hasOwnProperty(key)) {
          sections[key] = elements[key].offsetTop;
        }
      }

      window.addEventListener('scroll', onScroll);
    }

    function getDistance(el, x, y) {
      let elPos = el.getBoundingClientRect();
      return Math.floor(Math.sqrt(Math.pow(x - (elPos.left + (elPos.width / 2)), 2) + Math.pow(y - (elPos.top), 2)));
    }

    function initTabs() {

      const tabs = document.querySelectorAll('.wp-block-easee-tabbed-content');
      let i = 0;

      tabs.forEach(function (item) {
        i++;
        let myTabs = item.querySelectorAll(".tab-link");
        let myContentPanes = item.querySelectorAll(".tab-pane");

        function myTabClicks(e) {
          e.preventDefault()
          for (let i = 0; i < myTabs.length; i++) {
            myTabs[i].classList.remove("active");
            myContentPanes[i].classList.remove("active");
          }

          myContentPanes[this.getAttribute("href")].classList.add("active");
          this.classList.add("active");
        }

        for (i = 0; i < myTabs.length; i++) {
          myTabs[i].addEventListener("click", myTabClicks)
        }
      });

    }


    function initShare() {
      let shares = document.querySelectorAll('.btn-share');
      let image = getOpenGraphData('og:image') ? encodeURIComponent(getOpenGraphData('og:image')) : '';
      let title = getOpenGraphData('og:title') ? encodeURIComponent(getOpenGraphData('og:title')) : '';
      let text = getOpenGraphData('og:description') ? encodeURIComponent(getOpenGraphData('og:description')) : '';
      let url = getOpenGraphData('og:url') ? encodeURIComponent(getOpenGraphData('og:url')) : '';

      shares.forEach(function (share) {

        share.addEventListener("click", function (event) {

          let platform = this.getAttribute('data-platform');
          event.preventDefault();

          if (platform == 'facebook') {
            open(
              `
      https://www.facebook.com/sharer/sharer.php?u=${url}`,
              'facebook-share-dialog',
              'width=626,height=436'
            )
          }
          if (platform == 'twitter') {
            open(
              `https://twitter.com/share?ref_src=${url}&text=${title}`,
              'tshare',
              'height=400,width=550,resizable=1,toolbar=0,menubar=0,status=0,location=0')
          }
          if (platform == 'linkedin') {
            open(
              `https://www.linkedin.com/shareArticle?url=${url}&mini=true&title=${title}&text=${text}&image=${image}`,
              'lshare',
              'height=570,width=520,resizable=1,toolbar=0,menubar=0,status=0,location=0')
          }
        })
        ;
      })
      ;
    }

    function getOpenGraphData(property) {
      return document.querySelector(`meta[property="${property}"]`) ? document.querySelector(`meta[property="${property}"]`).getAttribute('content') : '';
    }

    function initModals() {
      const links = document.querySelectorAll('.modal-link');
      const modal = document.getElementById('modal');
      const content = modal.querySelector('.modal__content');
      const close = document.querySelector('.modal-close');

      links.forEach(function (item) {
        let isYoutube = item.classList.contains('modal-youtube');
        let video;

        item
          .addEventListener("click", function (event) {
            event.preventDefault();
            modal.classList.add("active");
            if (isYoutube) {
              video = document.createElement('div');
              video.classList.add('js-player', 'plyr__video-embed');
              video.innerHTML = `<iframe src="https://www.youtube.com/embed/${item.getAttribute('data-yt-id')}?origin=${encodeURI('https://easee.online')}&amp;iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1" allowfullscreen allowtransparency allow="autoplay"> </iframe>`
              content.appendChild(video)
              const player = new Plyr(video,
                {
                  "controls": ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'pip', 'airplay', 'fullscreen'],
                }
              );

// eslint-disable-next-line
              player.on('ready', event => {
                player.play(); // Start playback
              });

            }
          });

        close
          .addEventListener("click", function (event) {
            event.preventDefault();
            modal.classList.remove("active");
            setTimeout(function () {
              content.innerHTML = ''
            }, 1000)
          });
      });
    }


  },
  finalize() {
    // eslint-disable-next-line
  }
  ,
}
;



// WEBPACK FOOTER //
// ./scripts/common.js